import { useContext } from 'react';
import { useQuery } from '@apollo/client';
import { AppContext } from '@edx/frontend-platform/react';

import { GET_ENROLLED_PROGRAMS } from '../queries/enrolledPrograms';

export const useEnrolledPrograms = (enabled = true) => {
  const { authenticatedUser } = useContext(AppContext);
  const userId = authenticatedUser?.id ?? authenticatedUser?.userId;

  const { data, loading, error } = useQuery(GET_ENROLLED_PROGRAMS, {
    variables: { userId },
    skip: !userId || !enabled,
  });

  return {
    enrolledPrograms: data?.enrolledPrograms || [],
    loading,
    error,
  };
};
